export default "__VITE_ASSET__d5795db5__"